import { Box, Container, Grid, Typography } from '@mui/material';
import React from 'react';
import { useInView } from 'react-intersection-observer';
import CountUp from 'react-countup';
import umbrella from '../../assets/images/Travel/3d-umbrella-orange-white-object-orange-background-modern-icon_348818-3691.png';

const PersonalizedAssurance: React.FC = () => {
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.3,
    });

    interface Stat {
        value: number;
        label: string;
        display: string;
    }

    const leftStats: Stat[] = [
        { value: 1000000, label: 'Claims Processed till 2024', display: '1M' },
        { value: 2000, label: 'Happy Customers Worldwide', display: '2K' },
    ];

    const rightStats: Stat[] = [
        { value: 3000, label: 'Global Locations to Assist', display: '3K' },
        { value: 3000, label: 'Global Locations to Assist', display: '3K' },
    ];

    const formatNumber = (value: number): string => {
        if (value >= 1000000) return `${(value / 1000000).toFixed(0)}M`;
        if (value >= 1000) return `${(value / 1000).toFixed(0)}K`;
        return value.toString();
    };

    return (
        <>
            <Container sx={{ py: 5 }} ref={ref}>
                <Typography variant="h4" align="center" sx={{ mb: 4 }}>
                    Personalized Assurance Products for Every Customer, Every Moment.
                </Typography>

                <Box
                    sx={{
                        backgroundColor: '#1363df',
                        borderRadius: '10rem',
                        px: 3,
                        py: 5,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        position: 'relative',
                        flexWrap: 'wrap',
                    }}
                >
                    {/* Left Stats */}
                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 4 }}>
                        {leftStats.map((stat, index) => (
                            <Box
                                key={index}
                                sx={{
                                    textAlign: 'center',
                                    padding: '0 0rem',
                                }}
                            >
                                <Typography variant="h4" fontWeight="bold" color="#fff">
                                    {inView ? (
                                        <CountUp
                                            start={0}
                                            end={stat.value}
                                            duration={2.5}
                                            formattingFn={formatNumber}
                                            useEasing
                                        />
                                    ) : (
                                        '0'
                                    )}
                                </Typography>
                                <Typography variant="subtitle1" color="#fff">
                                    {stat.label}
                                </Typography>
                            </Box>
                        ))}
                    </Box>

                    {/* Umbrella Image */}
                    <Box
                        sx={{
                            mx: 4,
                            position: 'absolute',
                            zIndex: 1,
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%, -50%)',
                            maxWidth:'24rem',
                        }}
                    >
                        <img
                            src={umbrella}
                            alt="Umbrella"
                            className="umbrella-images img-fluid"
                        />
                    </Box>

                    {/* Right Stats */}
                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 4 }}>
                        {rightStats.map((stat, index) => (
                            <Box key={index} sx={{ textAlign: 'center' }}>
                                <Typography variant="h4" fontWeight="bold" color="#fff">
                                    {inView ? (
                                        <CountUp
                                            start={0}
                                            end={stat.value}
                                            duration={2.5}
                                            formattingFn={formatNumber}
                                            useEasing
                                        />
                                    ) : (
                                        '0'
                                    )}
                                </Typography>
                                <Typography variant="subtitle1" color="#fff">
                                    {stat.label}
                                </Typography>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Container>
            <Container sx={{ py: 5 }}>
                <Grid sx={{ textAlign: 'center' }}>
                    {/* <Box>
                        <Typography variant="h4">Experience</Typography>
                    </Box> */}
                    <Box>
                        <Typography
                            variant="h6"
                            sx={{
                                fontSize: {
                                    md: '1.2rem',
                                    xs: '.98rem',
                                    lg: '1.2rem',
                                },
                                fontWeight: '400',
                                lineHeight: '1.4',
                            }}
                        >
                            Partner with Across Assist to elevate your customer experience with
                            our wide range of assurance products—from roadside assistance and
                            gadget protection to health, travel, and corporate mobility.
                            Designed to suit any industry or budget, our customizable combos
                            help you drive engagement, increase customer touchpoints, and boost
                            lifetime value. Whether you're in BFSI, Travel, Automotive, Retail,
                            or beyond—we have the right solutions for you. Unlock new growth
                            opportunities with seamless integration and unmatched flexibility.
                        </Typography>
                    </Box>
                </Grid>
            </Container>
        </>
    );
};

export default PersonalizedAssurance;